const todoData = [
    {
        id:1,
        text: "Take out the trash",
        completed: true
    },
    {
        id:2,
        text: "Grocery Shopping",
        completed: false
    },
    {
        id:3,
        text: "Study something",
        completed: false
    },
    {
        id:4,
        text: "Clean the room",
        completed: false
    },
    {
        id:5,
        text: "Mow lawn",
        completed: true
    }
]

export default todoData